import React from 'react';
import PropTypes from 'prop-types';
import Image from '../Image';
import { StyledAvatar, StyledShortcut } from './styled';
import Icon from '../Icon';
import useTheme from '../../hooks/useTheme';

const Avatar = ({ alt, src, size, customSize, shortcut }) => {
  const theme = useTheme();
  return (
    <StyledAvatar
      size={size}
      customSize={customSize}
      gutter={!!!src}
    >
      {
        src ?
          <Image alt={alt} src={src} /> :
          (shortcut) ?
            <StyledShortcut>{shortcut}</StyledShortcut> :
            <Icon name="user" width="100%" height="100%" fill={theme.colors.white} />
      }
    </StyledAvatar>
  );
};

Avatar.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  customSize: PropTypes.number,
  shortcut: PropTypes.string
};

Avatar.defaultProps = {
  size: 'medium'
};

export default React.memo(Avatar);
